import { TextEditorFormat } from "@/components/controls/TextEditor/utils/restrictedMarkdown";

// What a multiline slot may hold; the composer draws the same formats.
export const SLOT_FORMATS: TextEditorFormat[] = [
  "bulletList",
  "orderedList",
  "bold",
  "italic"
];

// Lists and emphasis, wrapped item lines indented under the text, as the composer draws them.
export const SLOT_FORMATTED =
  "[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-[1.2em] [&_ol]:pl-[1.6em] [&_strong]:font-bold [&_em]:italic";
